/* eslint-disable import/no-webpack-loader-syntax */
import bet10a from '!!file-loader!./bet-0010-active.png'
import bet10i from '!!file-loader!./bet-0010-default.png'
import bet10d from '!!file-loader!./bet-0010-disabled.png'

import bet50a from '!!file-loader!./bet-0050-active.png'
import bet50i from '!!file-loader!./bet-0050-default.png'
import bet50d from '!!file-loader!./bet-0050-disabled.png'

import bet100a from '!!file-loader!./bet-0100-active.png'
import bet100i from '!!file-loader!./bet-0100-default.png'
import bet100d from '!!file-loader!./bet-0100-disabled.png'

import bet500a from '!!file-loader!./bet-0500-active.png'
import bet500i from '!!file-loader!./bet-0500-default.png'
import bet500d from '!!file-loader!./bet-0500-disabled.png'

import bet1000a from '!!file-loader!./bet-1000-active.png'
import bet1000i from '!!file-loader!./bet-1000-default.png'
import bet1000d from '!!file-loader!./bet-1000-disabled.png'

import bet3000a from '!!file-loader!./bet-3000-active.png'
import bet3000i from '!!file-loader!./bet-3000-default.png'
import bet3000d from '!!file-loader!./bet-3000-disabled.png'

interface BetIconSet {
  default: string
  active: string
  disabled: string
}

const imgs: { [amount: string]: BetIconSet } = {
  '10': {
    default: bet10i,
    active: bet10a,
    disabled: bet10d,
  },
  '50': {
    default: bet50i,
    active: bet50a,
    disabled: bet50d,
  },
  '100': {
    default: bet100i,
    active: bet100a,
    disabled: bet100d,
  },
  '500': {
    default: bet500i,
    active: bet500a,
    disabled: bet500d,
  },
  '1000': {
    default: bet1000i,
    active: bet1000a,
    disabled: bet1000d,
  },
  '3000': {
    default: bet3000i,
    active: bet3000a,
    disabled: bet3000d,
  },
}

export default imgs
